import { AppError } from './app-error';

export class ForbidenError extends AppError {
}
